const FitFacts = ({
    items
}) => (
    <div className="fit-facts-wrapper">
        <h4>
            ACE Fit Facts<sup>®</sup>
        </h4>

        {items.map((item, index) => (
            <FitFactItem
                key={`${item.label}-${index}`}
                link={item.link}
                label={item.label}
            />
        ))}
    </div>
)

export const FitFactItem = ({
    link,
    label
}) => (
    <div>
        <img src="/images/webcontent/assets/education-resources/lifestyle/acefit/pdficon.gif" alt="PDF icon" />&nbsp;
        <a
            className="blueDark size14"
            href={link}
        >
            {label}
        </a>
    </div>
)

export default FitFacts;